/**
 * Bảng màu chuyên nghiệp: nền sạch, một accent xanh rõ, shell tối giản (header đặc, sidebar trắng).
 */
export const uiPalette = {
  primary: {
    main: '#0070f4',
    dark: '#0055c0',
    light: '#3d94f7',
    surface: '#e8f2fe',
    surfaceBorder: '#c5daf5',
    hover: 'rgba(0, 112, 244, 0.08)',
  },
  neutral: {
    background: '#eceff3',
    backgroundDeep: '#e3e7ed',
    border: 'rgba(51, 51, 51, 0.08)',
    borderMedium: 'rgba(51, 51, 51, 0.14)',
    text: '#333333',
    textMuted: '#666666',
    /** Nhãn phụ / meta */
    textSubtle: '#999999',
  },
  shell: {
    headerSolid: '#0070f4',
    headerBorder: 'rgba(255, 255, 255, 0.14)',
    headerShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
    sidebarBg: '#ffffff',
    sidebarBorder: '#e2e8f0',
    /** Chữ menu: đậm hơn slate-600 để dễ đọc trên nền sáng */
    sidebarItem: '#1e293b',
    /** Icon menu: tương phản rõ hơn nhưng vẫn nhẹ hơn chữ */
    sidebarIcon: '#64748b',
    sidebarHoverBg: '#f1f5f9',
    sidebarActiveBg: '#eff6ff',
    sidebarActiveBgHover: '#dbeafe',
    sidebarActiveText: '#1d4ed8',
    sidebarActiveIcon: '#2563eb',
    sidebarActiveBar: '#2563eb',
    sidebarSectionBg: '#f1f5f9',
    sidebarSectionText: '#1e40af',
    sidebarSectionBar: '#64748b',
    sidebarOpenParentBg: '#fafafa',
    sidebarOpenParentBar: '#e2e8f0',
    popoverBg: '#ffffff',
    popoverBorder: '#e2e8f0',
    popoverShadow: '0 12px 40px rgba(15, 23, 42, 0.1)',
    navRail: 'rgba(148, 163, 184, 0.35)',
  },
  table: {
    /**
     * Thead: xám lạnh pha accent rất nhẹ — dễ đọc hơn nền xanh #e5f1fd cũ.
     * Đồng bộ `muahangKiotLike.invoiceTableHeaderBg`.
     */
    headBg: '#f3f5f8',
    /** Viền thead — xám trung tính, tránh kẻ dọc màu accent gắt. */
    headBorder: '#e4e7ec',
    headText: '#333333',
    /** Kẻ ô body — nhạt hơn #eeeeee để lưới đỡ rối. */
    cellBorder: '#f0f1f3',
    /** Hover hàng: xám nhạt (Kiot grid), không rgba để cột sticky không lộ nền */
    rowHoverBg: '#f5f7fa',
    paginationBg: '#f7f7f7',
    /** Viền khối bảng — xám nhạt. */
    wrapperBorder: '#e8eaed',
    /** Thead bảng cấp 2 (chi tiết trong panel expand / form). */
    level2HeadBg: '#f7f8fa',
    level2HeadBorder: '#e8eaed',
    level2HeadText: '#333333',
  },
  secondary: {
    main: '#0d9488',
    dark: '#0f766e',
    light: '#14b8a6',
  },
  status: {
    error: '#dc2626',
    warning: '#d97706',
    success: '#15803d',
  },
} as const
